exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".licence-category{display:flex;flex-direction:row}.licence-category__icon{font-size:12px;line-height:16px;font-weight:inherit;height:24px;color:#727e82;display:flex;flex-direction:row;align-items:center}.licence-category__licence{font-size:14px;margin-right:24px;display:flex;justify-content:center;align-items:center}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};